import PropTypes from "prop-types";
import React from "react";
import Header_Main from "../Wrappers/Header_Main";
import Footer_Main from "../Wrappers/Footer_Main";

function Layout({ children }) {
  return (
    <>
      <Header_Main />
      {children}
      <Footer_Main />
    </>
  );
}

Layout.propTypes = {
  children: PropTypes.any,
};

export default Layout;
